/**
 * Manages the Firebase configuration and imports required libraries.
 * Creates variables for collections, storage, etc... used throughout the app.
 * getCurrentUser function is used for route guarding.
 */

import firebase from 'firebase/compat/app'

import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/analytics'
import 'firebase/compat/storage'
import 'firebase/compat/functions'

import * as firebaseJSON from '../firebase.json'

const firebaseConfig = {
  apiKey: 'AIzaSyBihA0am9IdxbIydVrbe2jcL2YgCl8WneQ',
  authDomain: 'foxsports-fanmosaic-prod.firebaseapp.com',
  databaseURL: 'https://foxsports-fanmosaic-prod.firebaseio.com',
  projectId: 'foxsports-fanmosaic-prod',
  storageBucket: 'foxsports-fanmosaic-prod.appspot.com',
  messagingSenderId: '445176805329',
  appId: '1:445176805329:web:668247b1d143b9f140d2f0',
  measurementId: 'G-V2XP9MR6HB'
};

// Initialize Firebase
!firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app()
firebase.analytics()

// If enabled, start up Firebase emulators
if (process.env.VUE_APP_USE_FIREBASE_EMULATORS === 'true') {
  console.log('Running Firebase emulators...')
  firebase.functions().useEmulator('localhost', firebaseJSON.emulators.functions.port)
}

const auth = firebase.auth()
const db = firebase.firestore()

const storiesCollection = db.collection('stories')
const articlesCollection = db.collection('articles')
const indexCollection = db.collection('index')

const storage = firebase.storage().ref()

// Check to see if a user is authenticated (used for guarding routes)
function getCurrentUser () {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      unsubscribe()
      if (user) {
        console.log(`User ${user.uid} is logged in.`)
        resolve(user)
      } else {
        reject('A user is not logged in.')
      }
    })
  })
}

export {
  getCurrentUser,
  auth,
  db,
  storage,
  storiesCollection,
  articlesCollection,
  indexCollection
}